import React from 'react';
import classnames from 'classnames';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import styles from '../styles/components/breakdown.module.scss';
import { toggleModal } from '../store/reducers/modals';
import { pickProps } from '../helpers/hocs/pick-props';
import { AffiliateIcon } from './icons/affiliate-icon';
import { InformerIcon } from './icons/informer-icon';
import { Link as RouterLink } from './link';

const Informer = compose(
  connect(null, { toggleModal }),
  withHandlers({
    onClick:
      ({ data, toggleModal }) =>
      () => {
        toggleModal(true, 'help', data);
      }
  }),
  pickProps(['onClick', 'className', 'ariaLabel'])
)(InformerIcon);

const Entry = ({ renderAs: Component = 'span', className, nudge, ...props }) => (
  <div className={classnames({ [styles[nudge]]: nudge })}>
    <Component className={classnames(styles.entry, className)} {...props} />
  </div>
);

export const Value = props => <Entry className={styles.value} {...props} />;

export const Label = props => <Entry className={styles.label} {...props} />;

export const LabelValue = props => <Entry className={styles['label-value']} {...props} />;

export const Output = props => <Entry className={styles.output} {...props} />;

export const Link = ({ to, isExternal, ...props }) => (
  <Entry renderAs={RouterLink} to={to} isExternal={isExternal} className={styles.link} {...props} />
);

export const Info = props => <Entry renderAs={Informer} className={styles.explainer} {...props} />;

const EmptyIcon = props => <div className={styles['empty-icon']} {...props} />;

export const Row = React.memo(({ icon, total, atid, children }) => (
  <li className={classnames(styles.item, { [styles.total]: total })} data-atid={atid}>
    {icon ? <AffiliateIcon name={icon} className={styles.icon} /> : <EmptyIcon />}
    <div className={styles.data}>{children}</div>
  </li>
));

export const Breakdown = React.memo(({ atid, title, titleAs: Title = 'h3', className, children }) => (
  <summary className={classnames(styles.container, className)} data-atid={atid}>
    {title && (
      <hgroup className={styles.header}>
        <Title className={styles.title}>{title}</Title>
      </hgroup>
    )}
    <ul className={styles.list}>{children}</ul>
  </summary>
));
